
import { 
    uploadData, getData, destroyData
} from '@/store/config/method'

const requestInit = {
    page: 1,
    show: 10,
    sortBy: null,
    sorting: null,
    search: null,
    fmtype: []
}
const itemInit = {
    id: null,
    alt: null,
    description: null,
    file_groups: []
}
const fileDataInit = {
    url: null,
    name: null,
    size: null,
    isImage: false,
    file: null
}
const initialState = () => ({
    message: null,
    status: 0,
    meta: {},
    data: [],
    selectedGroups: [],
    tempSelectedGroups: [],
    galleryFile: [],
    request: {...requestInit},
    item: {...itemInit},
    fileData: {...fileDataInit},
    responseData: {},
    detail: {}
})
const state = initialState
 
const getters = {
    getMessage: state => state.message,
    getStatus: state => state.status,
    getData: state => state.data || [],
    getMeta: state => state.meta || {},
    getRequest: state => state.request,
    getItem: state => state.item,
    getFileData: state => state.fileData,
    getSelectedGroups: state => state.selectedGroups,
    getTempSelectedGroups: state => state.tempSelectedGroups,
    getGalleryFile: state => state.galleryFile,
    getResponseData: state => state.responseData,
    getDetail: state => state.detail
}

const actions = {
    clearData({commit}){
        commit('SET_ITEM',{...itemInit})
        commit('SET_FILE_DATA',{...fileDataInit})
        commit('SET_SELECTED_GROUPS', [])
    },
    resetRequest({commit}){
        commit('SET_REQUEST',{...requestInit})
    },
    resetItem({commit}){
        commit('SET_ITEM',{...itemInit})
    },
    resetFileData({commit}){
        commit('SET_FILE_DATA',{...fileDataInit})
    },
    resetSelectedGroups({commit}){
        commit('SET_SELECTED_GROUPS', [])
    },
    resetTempSelectedGroups({commit}){
        commit('SET_TEMP_SELECTED_GROUPS', [])
    },
    setRequest({commit}, value){
        commit('SET_REQUEST',value)
    },
    setItem({commit}, value){
        commit('SET_ITEM',{...value})
    },
    setFileData({commit}, value){
        commit('SET_FILE_DATA', value)
    },
    setSelectedGroups({commit}, value){
        commit('SET_SELECTED_GROUPS', value)
    },
    setTempSelectedGroups({commit}, value){
        commit('SET_TEMP_SELECTED_GROUPS', value)
    },
    async store({
        commit
    }, payload) {
        try {
            const response = await uploadData('api','/management/file',payload);
            commit('SET_RESPONSE', response.data);
            commit('SET_RESPONSE_DATA', response.data.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async fetchData({
        commit, state
    }){
        try {
            const response = await getData('api','/management/files',{params: state.request});
            commit('SET_RESPONSE', response.data);
            commit('SET_DATA', response.data.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async getDetailData({
        commit
    }, file_id){
        try {
            const url = `/management/file/${file_id}`
            const response = await getData('api',url);
            commit('SET_RESPONSE', response.data);
            commit('SET_DETAIL', response.data.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async getGalleryFileData({
        commit
    }, params = {}){
        try {
            const response = await getData('api','/management/files-gallery',{params});
            commit('SET_RESPONSE', response.data);
            commit('SET_GALLERY_FILE', response.data.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async update({
        commit
    }, {payload, id}) {
        try {
            const url = `/management/file/${id}`
            const response = await uploadData('api',url,payload);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async destroy({
        commit
    }, data) {
        try {
            const url = `/management/file/${data.id}`
            const response = await destroyData('api',url);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    resetState({commit}){
        commit('resetState')
    }
}

const mutations = {
    SET_FAILED(state) {
        state.message = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_FAILED_MESSAGE(state, error) {
        if(error.status == 400){
            state.message = error.data.message
            state.status = error.data.status
        }else{
            state.message = 'Jaringan Bermasalah'
            state.status = 0
        }
    },
    SET_RESPONSE(state, response) {
        state.message = response.message
        state.status = response.status
    },
    SET_RESPONSE_DATA(state, value) {
        state.responseData = value
    },
    SET_DATA(state, response) {
        state.data = response.data
        state.meta = {
            current_page: response.current_page,
            from: response.from,
            last_page: response.last_page,
            per_page: response.per_page,
            to: response.to,
            total: response.total
        }
    },
    SET_DETAIL(state, value) {
        state.detail = value
    },
    SET_REQUEST(state, value){
        state.request = value
    },
    SET_ITEM(state, value){
        state.item = value
    },
    SET_GALLERY_FILE(state, value){
        state.galleryFile = value
    },
    SET_FILE_DATA(state, value){
        state.fileData = value
    },
    SET_SELECTED_GROUPS(state, value){
        state.selectedGroups = value
    },
    SET_TEMP_SELECTED_GROUPS(state, value){
        state.tempSelectedGroups = value
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}